import { createModel } from "@rematch/core";
import { ethers } from "ethers";
// import { BigNumber } from "bignumber.js";
import { Role__factory } from "../contract/types/ethers-contracts/factories/Role__factory";
import { Role } from "../contract/types/ethers-contracts/Role";
import { MAIN_CONTRACT, RINKEBY_CONTRACT } from "../config/contract";
import { RootModel } from ".";

const CONFIG = MAIN_CONTRACT;

const CONTRACT_ADDRESS = CONFIG.role;
// const NET_ID = 4; // Rinkeby
const NET_ID = 1; //

interface Attributes {
  tokenId?: number;
  gender?: number;
  race?: number;
  alignment?: number;
  point: {
    strength: number;
    dexterity: number;
    constitution: number;
    charisma: number;
    intelligence: number;
    wisdom: number;
  };
}

declare global {
  interface Window {
    ethereum: ethers.providers.ExternalProvider;
  }
}

interface AlertState {
  open: boolean;
  type: "success" | "info" | "warning" | "error";
  content: string;
}

const initAlertState: AlertState = {
  open: false,
  type: "info",
  content: "",
};

interface UserInfo {
  address: string;
}

interface MainState {
  isMainNet?: boolean;
  alertState: AlertState;
  party: boolean;
  userInfo: UserInfo;
  ethersProvider?: ethers.providers.Web3Provider;
  signer?: ethers.providers.JsonRpcSigner;
  isContractInit?: boolean;
  RoleContract?: Role;
}

const initMainState: MainState = {
  alertState: initAlertState,
  userInfo: {
    address: "",
  },
  isContractInit: false,
  party: false,
};

export const main = createModel<RootModel>()({
  state: initMainState,
  reducers: {
    setFields(state, fields: Partial<MainState>): MainState {
      return {
        ...state,
        ...fields,
      };
    },
    openAlert(state, fields: Partial<AlertState>): MainState {
      let newAlertState = {
        ...state.alertState,
        ...fields,
        open: true,
      };
      return {
        ...state,
        alertState: newAlertState,
      };
    },
    closeAlert(state): MainState {
      return {
        ...state,
        alertState: initAlertState,
      };
    },
    setUserInfo(state, fields: Partial<UserInfo>): MainState {
      let newUserInfo = {
        ...state.userInfo,
        ...fields,
      };
      return {
        ...state,
        userInfo: newUserInfo,
      };
    },
  },
  effects: (dispatch) => ({
    async init() {
      const ethereum = window.ethereum;
      if (ethereum) {
        let ethersProvider = new ethers.providers.Web3Provider(ethereum, "any");
        let signer = ethersProvider.getSigner();
        dispatch.main.setFields({
          ethersProvider,
          signer,
        });
        dispatch.main.connectWallet();
        dispatch.main.initContract();
        dispatch.pets.initPetsContract();
        dispatch.rolePlus.initRolePlus();
      }
    },
    async initContract(_payload: any, state) {
      let { ethersProvider, signer } = state.main;
      if (ethersProvider && signer) {
        // 连接合约
        let RoleContract = Role__factory.connect(CONTRACT_ADDRESS, signer);
        let netWorkInfo = await ethersProvider.getNetwork();
        const isMainNet = netWorkInfo.chainId === NET_ID;
        dispatch.main.setFields({
          isMainNet,
          isContractInit: true,
          RoleContract,
        });
        // try {
        //   let SoldNum = await RoleContract.getSoldNum();
        //   console.log(
        //     "🚀 ~ file: main.ts ~ line 139 ~ initContract ~ UNIT_PRICE",
        //     UNIT_PRICE
        //   );
        //   dispatch.main.setFields({
        //     SoldNum: SoldNum.toNumber(),
        //     UNIT_PRICE: new BigNumber(
        //       ethers.utils.formatEther(UNIT_PRICE)
        //     ).toNumber(),
        //   });
        // } catch (error) {
        //   console.error(error);
        // }
      }
    },
    async connectWallet(_payload: any, state) {
      let walletAccounts;
      const ethereum = window.ethereum;
      if (ethereum) {
        try {
          walletAccounts = await ethereum.request!({
            method: "eth_requestAccounts",
          });
          console.log(
            "🚀 ~ file: main.ts ~ line 162 ~ connectWallet ~ walletAccounts",
            walletAccounts
          );
          dispatch.main.setUserInfo({ address: walletAccounts[0] });
        } catch (errorMsg: any) {
          if (errorMsg.code === 4001) {
            alert("Connect Cancel");
            // 用户取消连接网站
            // dispatch.main.openAlert({
            //   type: "error",
            //   content: error.message,
            // });
          }
        }
      }
    },
    async claim(payload: Attributes, state) {
      let { RoleContract } = state.main;
      if (RoleContract && payload) {
        let mintHash;
        try {
          mintHash = await RoleContract.claim(
            payload.tokenId!,
            payload.gender!,
            payload.race!,
            payload.alignment!,
            payload.point.strength,
            payload.point.dexterity,
            payload.point.constitution,
            payload.point.wisdom,
            payload.point.charisma,
            payload.point.intelligence
          );
          if (mintHash) {
            // dispatch.main.setTransactionModal({
            //   open: true,
            //   status: 0,
            //   txHash: mintHash.hash,
            // });
          }
          let result = await mintHash.wait();
          if (result.status === 1) {
            alert("Claim Success! You can check it on OpenSea!");
            // dispatch.main.openAlert({
            //   type: "success",
            //   content: "Congratulations! Transaction Confrimed!",
            // });
            // dispatch.main.setTransactionModal({
            //   txHash: mintHash.hash,
            //   open: true,
            //   status: 1,
            // });
          }
        } catch (error: any) {
          if (error?.code === 4001) {
            alert(error.message);
            // 用户取消连接网站
            // dispatch.main.openAlert({
            //   type: "error",
            //   content: error.message,
            // });
          } else {
            // dispatch.main.setTransactionModal({
            //   txHash: mintHash?.hash,
            //   open: true,
            //   status: 2,
            //   errorMsg: error.message,
            // });
          }
        }
      }
    },
  }),
});
